<svg class="{$$props.class}" viewBox="-98 0 483 483">
  <path
    fill="currentColor"
    d="M286 39.2A39.2 39.2 0 00246.8 0H39.2A39.2 39.2 0 000 39.2v404.6A39.2 39.2
    0 0039.2 483h207.6a39.2 39.2 0 0039.2-39.2zM155.8 428.9a12.8 12.8 0 11-25.6
    0 12.8 12.8 0 0125.6 0zm3.1-41.6l-5-8.9-28-50.5a11 11 0 0114 2l10.2 11.8a8 8
    0 0014-5.3v-85.3c0-1.7 1.7-2.1 2.7-2.1h3.9c1.3 0 2.6.6 2.6 2.1l-.3
    67.6v4.3a8 8 0 0016 0v-19.2c0-.5.7-.8 1.2-.8h8a.8.8 0 01.8.8v25.5a8 8 0 0016
    0V310a1.2 1.2 0 011.1-1h8c.5 0 .9.5.9 1v19.3a8 8 0 0016
    0v-2.9c0-.8.2-1.5.6-2 .3-.4.7-.5 1.1-.4h4.2a2.5 2.5 0 012.6 2.5V374.4A26.6
    26.6 0 01223 401h-40.9a26.6 26.6 0 01-23.1-13.7zM98.8 283a15 15 0 01-11-5
    12.6 12.6 0 01-3.2-9.9L94.6 180h8.4v20.8a8 8 0 1016 0V180h50v20.8a8 8 0 1016
    0V180h6.9l10.1 88c.4 3.6-.7 7-3.1 9.7a14.7 14.7 0 01-9.6
    4.8V251c0-10.2-8.2-18.1-18.6-18.1h-4a18.4 18.4 0 00-18.5 18.3V283zM169
    164h-50v-7.8c0-12.8 11.2-23.2 25-23.2s25 10.4 25 23.2zm96.5 162.4A18.6 18.6
    0 00247 308h-6.1a17 17 0 00-16.8-15h-7.9c-1.5 0-3 .2-4.4.6a16.7 16.7 0
    00-3-3 28.4 28.4 0 009.2-24.4l-11-95a8 8 0
    00-7.9-7.2h-14v-7.8c0-21.6-18.4-39.2-41-39.2s-41 17.6-41 39.2v7.8H87.5a8 8 0
    00-8 7.1l-10.9 95.1a29 29 0 007.1 22.4 31 31 0 0023 10.4h49.4v17.1a27.1 27.1
    0 00-33.8.6l-3.7 2.8a7.8 7.8 0 00-2.1 10l24.8
    44.5H16V94h254v280h-4.5v-22.7-24.9zM39.1 16H247A23.5 23.5 0 01270
    39.5V78H16V39.5A23.5 23.5 0 0139.1 16zM247 468H39A23.4 23.4 0 0116
    444.5V390h126.3l2.7 5c1 2 2.4 3.9 3.8 5.7a28.8 28.8 0 1023
    28.2c0-5-1.4-10-4-14.4a42.4 42.4 0 0014.3 2.5H223a42.3 42.3 0
    0039.5-27h7.5v54.5a23.5 23.5 0 01-23.1 23.5zm0 0" />
  <path
    fill="currentColor"
    d="M109.3 53h67.5a8 8 0 000-16h-67.6a8 8 0 000 16zm0 0" />
</svg>
